export default {
  ar() {
    return {
      accommodation: 'الاقامة',
      add: '',
      addToCart: 'اضافة الى سلة المشتريات',
      chooseYourPackage: 'اختر صفقتك',
      continue: 'Continue',
      discount: 'خصم',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}',
      error: 'حدث خطأ في إدخالك',
      noAccommodations: 'لا يوجد اماكن اقامة',
      numberOfPeople: 'كمية الصفقة',
      package: 'صفقة',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'اسعار الصفقات',
      packageQty: 'كمية الصفقة',
      paymentCount: 'or {count} payments of',
      chooseYourQuantity: 'الكمية',
      readyToCall: '<span>هل أنت مستعد للحجز؟ إتصل على {phoneLink}</span> أو إملأ النموذج لمعرفة خيارات الأسعار و الباقات.',
      roomQty: 'كمية الغرفة',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'المبلغ الاجمالي',
      takenInCart: 'الموجود فى العربة',
      viewCart: 'view your cart»'
    }
  },
  de() {
    return {
      accommodation: 'Unterkunft',
      add: '',
      addToCart: 'IN DEN WARENKORB',
      chooseYourPackage: 'Wählen Sie Ihr Paket aus',
      continue: 'Fortfahren',
      discount: 'Ermäßigung',
      dueDateTextTwo: 'Die Zahlungen werden gleichmäßig aufgeteilt und sind bei Unterzeichnung & am {date} fällig.',
      dueDateTextMultiple: 'Die Zahlungen werden gleichmäßig aufgeteilt und sind bei Vertragsabschluss fällig, am {datesList}',
      error: 'Bei Ihrer Übermittlung ist ein Fehler aufgetreten',
      noAccommodations: 'Keine Unterkünfte',
      numberOfPeople: 'Anzahl der Personen',
      package: 'Paket',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Paketpreis',
      packageQty: 'Anzahl Pakete',
      paymentCount: 'oder {count} Zahlungen von jen',
      chooseYourQuantity: 'Anzahl',
      readyToCall: '<span>Bereit für die Buchung? Rufen Sie uns unter {phoneLink}</span> an oder füllen Sie das Formular aus, um Preis- und Paketoptionen zu erhalten.',
      roomQty: 'Anzahl Zimmer',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'Zwischentotal:',
      takenInCart: '(im Warenkorb eingegangen)',
      viewCart: 'view your cart»'
    }
  },
  en() {
    return {
      accommodation: 'Accommodation',
      add: 'ADD',
      addToCart: 'ADD TO CART',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'Continue',
      discount: 'Discount',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}',
      error: 'There was an error with your submission',
      noAccommodations: 'No Accommodations',
      numberOfPeople: '# of People',
      package: 'Package',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Package Pricing',
      packageQty: 'Package Qty',
      paymentCount: 'or {count} payments of',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Ready to Book? Call {phoneLink}</span> or complete the form for pricing and package options.',
      roomQty: 'Room Qty',
      roomType: 'Room Type',
      soldOut: 'Sold Out',
      subtotal: 'Subtotal:',
      takenInCart: '(Taken in Cart)',
      yourTicket: 'Your Ticket',
      viewCart: 'view your cart»'
    }
  },
  enGB() {
    return {
      accommodation: 'Accommodation',
      add: 'ADD',
      addToCart: 'ADD TO BASKET',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'Continue',
      discount: 'Discount',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}',
      error: 'There was an error with your submission',
      noAccommodations: 'No Accommodations',
      numberOfPeople: '# of People',
      package: 'Package',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Package Pricing',
      packageQty: 'Package Qty',
      paymentCount: 'or {count} payments of',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Ready to Book? Call {phoneLink}</span> or complete the form for pricing and package options.',
      roomQty: 'Room Qty',
      roomType: 'Room Type',
      soldOut: 'Sold Out',
      subtotal: 'Subtotal:',
      takenInCart: '(Taken in Basket)',
      yourTicket: 'Your Ticket',
      viewCart: 'view your cart»'
    }
  },
  esMX() {
    return {
      accommodation: 'Alojamiento',
      add: '',
      addToCart: 'Añadir al Carrito',
      chooseYourPackage: 'Elija Su Paquete',
      continue: 'Continuar',
      discount: 'Descuento',
      dueDateTextTwo: 'Los pagos serán divididos en dos partes iguales y son pagaderos al firmar en {date}',
      dueDateTextMultiple: 'Los pagos serán divididos de manera equitativa y serán pagaderos al momento de la firma en {datesList}',
      error: 'Hubo un error con el envío de su información',
      noAccommodations: 'Sin Alojamiento',
      numberOfPeople: 'Número de personas',
      package: 'Paquete',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Precio de Paquete',
      packageQty: 'Cantidad de Paquetes',
      paymentCount: 'o {count} pagos de',
      chooseYourQuantity: 'Escoge tu Cantidad',
      readyToCall: '<span>¿Listo Para Reservar? Llame al {phoneLink}</span> o llene el formulario para obtener las opciones de precios y paquetes.',
      roomQty: 'Cantidad de Habitaciones',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'Total parcial:',
      takenInCart: '(en el carrito)',
      viewCart: 'view your cart»'
    }
  },
  fr() {
    return {
      accommodation: 'Hébergement',
      add: '',
      addToCart: 'Ajouter au panier',
      chooseYourPackage: 'Choisissez votre forfait',
      continue: 'Continuer',
      discount: 'Remise',
      dueDateTextTwo: 'Le paiement sera divisé en versements égaux dus à la signature du contrat et à la date du {date}.',
      dueDateTextMultiple: 'Le paiement sera divisé en versements égaux dus à la signature du contrat et aux dates suivantes : {datesList}',
      error: 'Une erreur est survenue lors de l\'envoi.',
      noAccommodations: 'Pas d\'hébergement',
      numberOfPeople: 'Nombre de personnes',
      package: 'Forfait',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Tarif forfaitaire',
      packageQty: 'Nombre de forfaits',
      paymentCount: 'ou {count} paiements de',
      chooseYourQuantity: 'Quantité',
      readyToCall: '<span>Prêt à réserver ? Appelez-nous au {phoneLink}</span> ou remplissez le formulaire pour les options de prix et de forfait.',
      roomQty: 'Nombre de chambres',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'Sous-total:',
      takenInCart: '(pris dans le panier)',
      viewCart: 'view your cart»'
    }
  },
  it() {
    return {
      accommodation: 'Sistemazione',
      add: '',
      addToCart: 'AGGIUNGI AL CARRELLO',
      chooseYourPackage: 'Scegli il tuo pacchetto',
      continue: 'Continua',
      discount: 'Sconto',
      dueDateTextTwo: 'I pagamenti verranno suddivisi in due importi uguali che dovranno essere pagati alla firma e in data {date}',
      dueDateTextMultiple: 'I pagamenti verranno suddivisi in due importi uguali che dovranno essere pagati alla firma e in data {datesList}',
      error: 'Si è verificato un errore durante l\'invio dei dati',
      noAccommodations: 'Nessuna sistemazione',
      numberOfPeople: 'Numero di persone',
      package: 'Pacchetto',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Prezzo del pacchetto',
      packageQty: 'N. di pacchetti',
      paymentCount: 'oppure {count} pagamenti da',
      readyToCall: '<span>Pronto a prenotare? Chiama subito al numero {phoneLink}</span> oppure completa il modulo se desideri conoscere i prezzi e le opzioni dei pacchetti.',
      chooseYourQuantity: 'Quantità',
      roomQty: 'N. di camere',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'Totale parziale:',
      takenInCart: '(nel carrello)',
      viewCart: 'view your cart»'
    }
  },
  ja() {
    return {
      accommodation: 'ご宿泊',
      add: '',
      addToCart: 'カートに追加',
      chooseYourPackage: 'パッケージを選択',
      continue: 'Continue',
      discount: 'ディスカウント',
      dueDateTextTwo: '支払いは、署名時と {date} の均等な分割になります',
      dueDateTextMultiple: '{datesList}の署名時に均等な分割のお支払いになります',
      error: '送信にエラーがありました。',
      noAccommodations: '宿泊なし',
      numberOfPeople: '人々の数',
      package: 'パッケージ',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'パッケージ価格',
      packageQty: 'パッケージ数量',
      paymentCount: 'または {count} 支払い',
      chooseYourQuantity: '数量',
      readyToCall: '<span>予約しますか? 電話{phoneLink}</span> または価格設定とパッケージオプション用フォームをご記入ください。',
      roomQty: '部屋数',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: '小計 :',
      takenInCart: '（カートに追加されました）',
      viewCart: 'view your cart»'
    }
  },
  pl() {
    return {
      accommodation: 'noclegi',
      add: '',
      addToCart: 'DODAJ DO KOSZYKA',
      chooseYourPackage: 'wybierz pakiet dla siebie',
      continue: 'Continue',
      discount: 'rabat',
      dueDateTextTwo: 'płatności zostaną podzielone na równe raty, należne w momencie zamówienia i {date}',
      dueDateTextMultiple: 'płatności zostaną podzielone na równe raty, należne w momencie zamówienia w poniższych terminach: {datesList}',
      error: 'wystąpił błąd w Twoim zgłoszeniu',
      noAccommodations: 'bez noclegów',
      numberOfPeople: 'liczba ludzi',
      package: 'pakiet',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'cena pakietu',
      packageQty: 'liczba pakietów',
      paymentCount: 'lub {count} raty w wysokości',
      readyToCall: '<span>Gotowy do rezerwacji? Zadzwoń pod numer {phoneLink}</span> lub wypełnij formularz, aby otrzymać cennik i listę pakietów.',
      chooseYourQuantity: 'ilość',
      roomQty: 'liczba pokoi',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: 'suma:',
      takenInCart: '(w koszyku)',
      viewCart: 'view your cart»'
    }
  },
  zhCN() {
    return {
      accommodation: '住宿',
      add: '',
      addToCart: '添加至购物车',
      chooseYourPackage: '选择您的套餐',
      continue: '继续',
      discount: '折扣',
      dueDateTextTwo: '款项将平分，并在签署日及{date}到期',
      dueDateTextMultiple: '付款将按期支付，并在签署日{datesList}全部支付完毕',
      error: '提交时出错',
      noAccommodations: '无住宿',
      numberOfPeople: '人数',
      package: '套餐',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: '套餐定价',
      packageQty: '套餐数量',
      paymentCount: '或{count} 款项',
      chooseYourQuantity: '数量',
      readyToCall: '<span>准备预订？请致电{phoneLink}</span>或填写表格，并选好价格和套餐。',
      roomQty: '房间数量',
      roomType: 'Room Type',
      soldOut: '',
      subtotal: '小计：',
      takenInCart: '（已在购物车中）',
      viewCart: 'view your cart»'
    }
  }
}
